export const getStatisticsSelector = store => {
    return store.getIn(['dashboard', 'statistics'])
}

export const getstatisticsCountSelector = store => {
    return store.getIn(['dashboard', 'statisticsCount'])
}
